import React from 'react';
import { SessionTimeline } from './SessionTimeline';
import './BreakManagerModal.css';

export const BreakManagerModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Break Manager</h2>
                    <button className="modal-close-btn" onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className="modal-body">
                    <SessionTimeline />
                </div>
            </div>
        </div>
    );
};
